import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";

/* function to delete a document from firstore */

export default function DeleteItem(props) {
  // const handleDelete = async () => {
  //   const itemsDocRef = doc(db, "items", props.idd);
  //   try {
  //     await deleteDoc(itemsDocRef);
  //   } catch (err) {
  //     alert(err);
  //   }
  // };

  return (
    <button
      type="button"
      id="btnDelete"
      class="btn btn-danger btn-md center-block"
      Style="width: 100px;"
      onClick={() => props.handleDelete(props.idd)}
    >
      Delete
    </button>
  );
}
